import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserDelete($user_uid: String!){
        user_delete (user_uid: $user_uid) {
            success
        }
    }
`;

export async function userDelete(user_uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ user_delete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { user_uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_delete;
}
